<svg
    [attr.width]="size"
    [attr.height]="size"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    [class]="'rise-agent-icon rise-agent-icon--' + variant"
    aria-hidden="true">
    <!-- Four-pointed star -->
    <path
        class="rise-agent-icon__star"
        d="M33.4627 20.4298C33.5823 19.8871 34.4177 19.8871 34.5373 20.4298C37.0094 31.6453 41.1047 35.7406 52.3202 38.2127C52.8629 38.3323 52.8629 39.1677 52.3202 39.2873C41.1047 41.7594 37.0094 45.8547 34.5373 57.0702C34.4177 57.6129 33.5823 57.6129 33.4627 57.0702C30.9906 45.8547 26.8953 41.7594 15.6798 39.2873C15.1371 39.1677 15.1371 38.3323 15.6798 38.2127C26.8953 35.7406 30.9906 31.6453 33.4627 20.4298Z" />
    <!-- Circle dot -->
    <path
        class="rise-agent-icon__dot"
        d="M46 21.75C49.0376 21.75 51.5 19.2876 51.5 16.25C51.5 13.2124 49.0376 10.75 46 10.75C42.9624 10.75 40.5 13.2124 40.5 16.25C40.5 19.2876 42.9624 21.75 46 21.75Z" />
</svg>
